import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@saucelabs/sl-component-grid';

import * as Styles from './AppsTableEmptyState.styles';
import EmptyStateBot from './assets/saucebot-chair.svg';
import NoticeForOldUsers from '../NoticeForOldUsers';

const AppsTableEmptyState = ({ onUploadClick, isOpen }) => (
  <Row
    className={Styles.base}
  >
    <Col xs={4}>
      <Row center="xs">
        <EmptyStateBot />
      </Row>
    </Col>
    <Col xs={8}>
      <h2 className={Styles.heading}>Your app repository is empty.</h2>
      <p className={Styles.subtitle}>
        <a
          className={Styles.link}
          onClick={() => onUploadClick(!isOpen)}
          role="button"
          tabIndex="0"
        >
          Upload
        </a>
        {' your first app and start testing.'}
      </p>
      <NoticeForOldUsers />
    </Col>
  </Row>
);

AppsTableEmptyState.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onUploadClick: PropTypes.func.isRequired,
};

export default AppsTableEmptyState;
